import React, { Component } from 'react';
import * as d3 from "d3";
import numeral from "numeral";
import tooltip from "./Tooltip.js";
import utils from "./utils.js";
const customFormat = (value, format) => {
  if(typeof format === 'string'){
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value)
  }else{
    return value;
  }
}

export default class AreaChart extends Component {
  constructor(props) {
    super(props)

    
  }
  componentDidMount() {
    this.renderArea()
  }
  componentWillReceiveProps(nextProps){
    if((!typeof(nextProps.areaChartChildComponent)=='object') || (nextProps.areaChartChildComponent==null)){
      this.renderArea(nextProps)
    }
    
  }

  componentDidUpdate() {
  }
  componentWillUnmount(){
    hideDetail();    
  }

  renderArea(nextProps){
    var { yAxisScale,xAxisScale, margins, data, svgDimensions,xField,yField,fillColor,strokeColor,isGroupBar,groupIndex,curveStyle,
          type,xAxisData,dataLabels,marker,id,mainDivId,tooltip,name,showAreaChartTooltip,hideAreaChartTooltip,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition, lineStyle  } =nextProps || this.props;
    curveStyle=(curveStyle!=undefined || curveStyle!=null) ? curveStyle : 'curveLinear';
    const { height } = svgDimensions;
    var defaultDataLabelFormat=function(d){
      return d;
    };//"0,0.[00]"
    tooltipStyle.format= tooltipStyle.format!=undefined ? tooltipStyle.format : ((yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat);
    tooltipStyle.prefix= tooltipStyle.prefix!=undefined ? tooltipStyle.prefix : ((yAxisScale.labels && yAxisScale.labels.prefix) || '');
    tooltipStyle.postfix= tooltipStyle.postfix!=undefined ? tooltipStyle.postfix : ((yAxisScale.labels && yAxisScale.labels.postfix) || '');
    var curveStyle = 'curveLinear';
    if(type=='areaspline'){
        curveStyle = 'curveCardinal';
    }
    var area = d3.area()
    .curve(d3[curveStyle])
    .x(function(d) { 
        return xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2); 
    })
    .y0(svgDimensions.height- margins.bottom)
    .y1(function(d) { 
        return yAxisScale.scale(d.yAxisValue);
     });

     var preparedData=[];
     xAxisData.forEach(function(d,index){
      d=(d!=null && typeof(d)=='object') ? d.data : d;
      if(data[index]!=null){
        if(data[index]!=null && typeof data[index] == 'object'){
          preparedData.push($.extend({data:data[index]}, {
            xAxisValue:(d!=null && typeof(d)=='object') ? d.data : d,
            yAxisValue:(data[index]!=null && typeof(data[index])=='object') ? data[index]["data"]:data[index]
          }));
        } else {
          preparedData.push({
            xAxisValue:(d!=null && typeof(d)=='object') ? d.data : d,
            yAxisValue:(data[index]!=null && typeof(data[index])=='object') ? data[index]["data"]:data[index]
          });
        }
      }
       // preparedData.push({
       //   xAxisValue:d,
       //   yAxisValue:data[index]
       // });
     });
     if(typeof(fillColor)=='object'){
      var linearGradient=fillColor.linearGradient || [0,0,0,0];
      var stops=fillColor.stops ||  [
        [0, 'red'],
        [1, 'green']
    ]
      d3.selectAll('#AreaChartGradientColorContainer_'+this.props.id).append("linearGradient")
      .attr("id", "AreaChartGradientColor_"+this.props.id)
      .attr("gradientUnits", "userSpaceOnUse")
      .attr("x1", linearGradient[0]*svgDimensions.width/100).attr("y1", linearGradient[1]*svgDimensions.height/100)
      .attr("x2", linearGradient[2]*svgDimensions.width/100).attr("y2", linearGradient[3]*svgDimensions.height/100)
    .selectAll("stop")
      .data([
        {offset: "0%", color: stops[0][1]},
        {offset: "100%", color:stops[1][1]}
      ])
    .enter().append("stop")
      .attr("offset", function(d) { return d.offset; })
      .attr("stop-color", function(d) { return d.color; });
      fillColor="url(#AreaChartGradientColor_"+this.props.id;
     }
    
    strokeColor= strokeColor!=null ? strokeColor : fillColor;
    var fillColor=(lineStyle.fillColor ? lineStyle.fillColor : fillColor);
    var strokeOpacity=(lineStyle.strokeOpacity ? lineStyle.strokeOpacity : 1);
    var strokeDashArray=(lineStyle.strokeDashArray ? lineStyle.strokeDashArray : 0);
    var strokeWidth=(lineStyle.strokeWidth ? lineStyle.strokeWidth : 2);

    d3.selectAll('#AreaChartContainer_'+this.props.id).selectAll("*").remove();
    d3.selectAll('#AreaChartContainer_'+this.props.id)
    .append("path")
    .data([preparedData])
    .attr("fill",fillColor)
    .style("fill-opacity",1)
    .attr("stroke",strokeColor)
    // .attr("stroke-width",2)
    .style("stroke-dasharray",strokeDashArray)
    .style("stroke-opacity",strokeOpacity)
    .attr("stroke-width",strokeWidth)
    .attr("class", "area")
    .attr("d", area);
     var that=this;
     //CBT:this is for data label
    if(dataLabels!=undefined && dataLabels !=null && dataLabels.enabled==true){
      var format=dataLabels.format || (yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat;
      var prefix=dataLabels.prefix || (yAxisScale.labels && yAxisScale.labels.prefix) || "";
      var postfix=dataLabels.postfix || (yAxisScale.labels && yAxisScale.labels.postfix) || "";
      d3.selectAll('#AreaChartLabelTextContainer_'+that.props.id).selectAll('*').remove();
      data.forEach(function(datum,index) {
        var xAxisLabels= (xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index]["data"] :xAxisData[index] ;
        var style=$.extend({'textAnchor':'middle'},false,(dataLabels && dataLabels.style ? dataLabels.style :{}));
          d3.selectAll('#AreaChartLabelTextContainer_'+that.props.id)
          .append('text')
          .attr("x",xAxisScale.scale(xAxisLabels)+(xAxisScale.scale.bandwidth()/2))
          .attr('y',yAxisScale.scale(datum)-5)
          .style("fill",'#000')
          .attr('style',utils.convertReactStyleToHtml(style))
          .text(prefix+""+customFormat(datum,format)+""+postfix);
        })
    }
    //CBT:This is for marker
      var globalTooltipShowLine=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.showLine || false ) : false;
      var globalTooltipCategory=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.category || '' ) : '';
      var symbol=marker.symbol || 'circle';
      var fillColorMarker=(marker.fillColor!=undefined && marker.fillColor !=null) ? marker.fillColor :'transparent';
      var strokeColorMarker=(marker.strokeColor!=undefined && marker.strokeColor !=null) ? marker.strokeColor :fillColorMarker;
      var strokeWidthMarker=(marker.strokeWidth!=undefined && marker.strokeWidth !=null) ? marker.strokeWidth :"4px";
      var radius=marker.radius || 5;
      var hilightColorMarker=(marker.hilightColor!=undefined && marker.hilightColor !=null) ? marker.hilightColor : fillColorMarker;
      var hilightStrokeColorMarker=(marker.hilightStrokeColor!=undefined && marker.hilightStrokeColor !=null) ? marker.hilightStrokeColor : strokeColorMarker;
      var hilightStrokeWidthMarker=(marker.hilightStrokeWidth!=undefined && marker.hilightStrokeWidth !=null) ? marker.hilightStrokeWidth : strokeWidthMarker;
      var hilightRadius=marker.hilightRadius || radius;

      if(symbol=='circle'){
        d3.selectAll("#AreaChartMarkerContainer_"+that.props.id).selectAll('*').remove();
        var markersCircle=d3.selectAll("#AreaChartMarkerContainer_"+that.props.id)
        .selectAll("circle")
        .data(preparedData).enter()
        .append('circle')
        .attr("data",function(d,index){
              var globalData={xAxisTooltipsLabel:d.xAxisValue,
                dataIndex:index,
                x:xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2),
                y:yAxisScale.scale(d.yAxisValue),
                r:radius
              }
              return JSON.stringify(globalData);
        })
        .attr('cx',function(d){
          return xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2)
        })
        .attr('cy',function(d){
          return yAxisScale.scale(d.yAxisValue)
        })
        .attr("r",function(d){
          if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
            return hilightRadius;
          }else{
          return radius;
          }
        })
        .style("stroke-width",function(d){
          if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
            return hilightStrokeWidthMarker;
          }else{
            return strokeWidthMarker;
          }
        })
        .style("stroke",function(d){
          if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
            return hilightStrokeColorMarker;
          }else{
            return strokeColorMarker;
          }
        })
        .style("fill",(marker.fillColor!=undefined && marker.fillColor !=null) ? fillColorMarker :'transparent')
        .style("stroke-opacity",1);

        //CBT:THis is for tooltips 
      if(tooltip==true || globalTooltip==true){
        markersCircle.on("mouseenter",null);
        markersCircle.on("mouseenter",(e)=>{
          d3.select(d3.event.target).transition().style("stroke-opacity",0.5);
          showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
        })
        if(tooltipPosition.toLowerCase()=='cursor'){
          markersCircle.on("mousemove",null);
          markersCircle.on("mousemove",(e,index)=>{
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
          });
        }
        markersCircle.on("mouseout",null);
        markersCircle.on("mouseout",function(d,mouseEvent){
          d3.select(d3.event.target).transition().style("stroke-opacity",0);
          hideDetail();
        });
      }else if(tooltip!=false && typeof(tooltip)=='object'){
          markersCircle.on("mouseenter",null);
          markersCircle.on("mouseenter",(e)=>{
            var cx=xAxisScale.scale(e.xAxisValue)+(xAxisScale.scale.bandwidth()/2);
            var cy=yAxisScale.scale(e.yAxisValue)
            showAreaChartTooltip(tooltip,{x:cx,y:cy,radius:radius,id:id,tooltipStyle:tooltipStyle}); 
          });
          markersCircle.on("mouseout",null);
          markersCircle.on("mouseout",function(d){
            hideAreaChartTooltip();
          });
        
       }
      }
    
    
  }

  // convertReactStyleToHtml=(rectStyleObj)=>{
  //   var htmlStyleObj='';
  //   if(rectStyleObj.hasOwnProperty("textAnchor")){
  //     htmlStyleObj=htmlStyleObj+'text-anchor:'+rectStyleObj.textAnchor+";";
  //   }
  //   if(rectStyleObj.hasOwnProperty("fill")){
  //     htmlStyleObj=htmlStyleObj+'fill:'+rectStyleObj.fill+";";
  //   }
  //   if(rectStyleObj.hasOwnProperty("fontSize")){
  //     htmlStyleObj=htmlStyleObj+'font-size:'+rectStyleObj.fontSize+";";
  //   }
  //   if(rectStyleObj.hasOwnProperty("fontStyle")){
  //     htmlStyleObj=htmlStyleObj+'font-style:'+rectStyleObj.fontStyle+";";
  //   }
  //   if(rectStyleObj.hasOwnProperty("fontFamily")){
  //     htmlStyleObj=htmlStyleObj+'font-family:'+rectStyleObj.fontFamily+";";
  //   }
  //   return htmlStyleObj;
  // }
  render() {
    const { yAxisScale,xAxisScale, margins, data, svgDimensions,xField,yField,fillColor,isGroupBar,groupIndex } = this.props
    const { height } = svgDimensions;
    var that=this;

    return (
        <g>
        <g
        id={"AreaChartGradientColorContainer_"+this.props.id}
        transform={"translate(0,0)"}></g>
        <g
        className={'AreaChartContainer_'+this.props.id}
        id={"AreaChartContainer_"+this.props.id}
        transform={"translate(0,0)"}
        ref={(el) => { this.areaContainer = el; }}
        />
        <g
        id={"AreaChartLabelTextContainer_"+this.props.id}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"AreaChartMarkerContainer_"+this.props.id}
          transform={"translate(0,0)"}>

        </g>
        { React.Children.count(this.props.children) ? 
        <g className="areaChartChildComponent">
          { React.Children.map(this.props.children,function(child,index){
              return (<g key={index}  className="areaChartChildComponent">{child}</g>);
            })
          }
        </g> 
        : null
        }  
      </g>
    )
  }
}

export function showDetail(props, data, mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition) {
  var defaultValueFormat=function(d){
      return d;
    };
  var labelFontSize =tooltipStyle.labelFontSize ||  "12px";
  var labelFontColor =tooltipStyle.labelFontColor ||  "black";
  var labelFontFamily = tooltipStyle.labelFontFamily ||  "";
  var valueFontSize =tooltipStyle.valueFontSize ||  "12px";
  var valueFontColor =tooltipStyle.valueFontColor ||  "black";
  var valueFontFamily =tooltipStyle.valueFontFamily ||  "";
  if(props.tooltip===true){
    var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
    var format=tooltipStyle.format || defaultValueFormat;
    var prefix=tooltipStyle.prefix || '';
    var postfix=tooltipStyle.postfix || '';
    data.map(function(d) {
      var content = `<tr>
          <td colspan="2" class="value"  style="text-align: center;letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
        d["name"]
      }</td></tr>`;
      delete d.name;
      var tooltipsContents = Object.keys(d);
      tooltipsContents.map(function(data) {
        content =
          content +
          `<tr><td class="key" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${labelFontSize};font-family:${labelFontFamily};color:${labelFontColor}">${data} </td>
              <td class="value" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
                prefix+""+customFormat( d[data],format)+""+postfix
          }</td></tr>`;
      });
  
      d["content"] = content;
      d["x"] = (tooltipPosition=="cursor")? d3.event.x : globalData.x + $("#" + props.id).offset().left;//d3.event.x;
      d["y"] =(tooltipPosition=="cursor")? d3.event.y : globalData.y+ $("#" + props.id).offset().top;// d3.event.y;
      d["mainDivId"] = props.id;
      d["marginLeft"] = props.margins.left;
      d["marginTop"] = props.margins.top;
    });
    tooltip.showTooltip(data, d3.event, "tooltip_map",(tooltipPosition=="cursor") ?  true :false,globalTooltip);//,isMouseMove,isGlobalTooltip
  }else{
  }  
  
}

export function hideDetail(d) {
  tooltip.hideTooltip();
}